import { Box, Button, TextField } from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import RemoveOutlinedIcon from "@material-ui/icons/RemoveOutlined";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import { TF } from "../../../components/typography/TF";

const QuoteAddonChangeQuantity = ({
  addon,
  onChangeQuantity,
  hideOnSmall,
  hideOnMin,
  showRecommend,
  showOneLine,
  disabled
}: Props) => {
  if (!addon) {
    return null;
  }

  if (hideOnMin && addon.quantity === 1 && addon.maxQuantity === 1) {
    return null;
  }

  const onRemoveQuantity = async function () {
    if (onChangeQuantity) {
      await onChangeQuantity(addon, addon.quantity - 1);
    }
  };

  const onAddQuantity = async function () {
    if (onChangeQuantity) {
      await onChangeQuantity(addon, addon.quantity + 1);
    }
  };

  const quantitySimple = <Box>{addon.quantity}</Box>;

  if (hideOnSmall) {
    return quantitySimple;
  }

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChangeQuantity) {
      await onChangeQuantity(addon, Number(event.target.value));
    }
  };

  const helpSection =
    showRecommend && addon.maxQuantity > 1 && addon.maxQuantity === addon.quantity ? (
      <Box mt={1}>
        <TF variant="caption">Our assessor has recommended the maximum quantity for your installation.</TF>
      </Box>
    ) : null;

  return addon.isFixedQuantity || addon.maxQuantity === 1 ? (
    quantitySimple
  ) : (
    <Box display={showOneLine ? "flex" : "block"}>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box>
          <Button size="small" onClick={onRemoveQuantity} disabled={addon.quantity === 1 || disabled}>
            <RemoveOutlinedIcon />
          </Button>
        </Box>
        <Box width="3rem">
          <TextField
            variant="outlined"
            size="small"
            onChange={handleChange}
            value={addon.quantity}
            disabled={disabled}
          />
        </Box>
        <Box>
          <Button size="small" disabled={addon.quantity === addon.maxQuantity || disabled} onClick={onAddQuantity}>
            <AddOutlinedIcon color="secondary" />
          </Button>
        </Box>
      </Box>
      {helpSection}
    </Box>
  );
};
export default QuoteAddonChangeQuantity;

interface Props {
  className?: string;
  addon: QuoteLineItem;
  hideOnSmall: boolean;
  hideOnMin: boolean;
  showRecommend: boolean;
  showOneLine: boolean;
  onChangeQuantity: (addon: QuoteLineItem, quantity: number) => void;
  disabled: boolean;
}
